module.exports = __webpack_public_path__ + "static/Image-4cb4c117895eb17998dbd59a15af6a9b.png";